import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BotaoPadrao from "../../../components/botao-padrao";
import styles from "./styles.module.css";

const formatoNumero = (valor) =>
  Number(valor || 0).toLocaleString("pt-BR", {
    maximumFractionDigits: 0,
  });

const formatoPercentual = (valor) =>
  `${Number(valor || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;

const LABEL_AGRUPAMENTO = {
  local_votacao: "Local de Votação",
  zona: "Zona",
  municipio: "Município",
};

const LABEL_METRICA = {
  quantidade_eleitores: "Quantidade de Eleitores",
  percentual_no_agrupamento: "% no Agrupamento",
  percentual_no_total_filtrado: "% no Total Filtrado",
};

const RelatorioPerfilEleitorado = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dados = state?.dados || [];
  const tipo = state?.tipo_agrupamento;
  const perfilAplicado = state?.perfil_aplicado || null;
  const imprimir = () => window.print();

  if (!dados.length) {
    return (
      <div className="formContainer">
        <h2 className="titulo">Nenhum resultado encontrado</h2>
        <BotaoPadrao
          label="Voltar para Filtros"
          onClick={() => navigate("/relatorios/perfil-eleitorado")}
        />
      </div>
    );
  }

  const labelTipo = {
    local_votacao: "Locais de Votação",
    zona: "Zonas",
    municipio: "Municípios",
  }[tipo];

  return (
    <div className={styles.container}>
      <div className={styles.actions}>
        <BotaoPadrao label="Imprimir / Exportar PDF" onClick={imprimir} />
        <BotaoPadrao
          label="Voltar"
          onClick={() => navigate("/relatorios/perfil-eleitorado")}
        />
      </div>

      <div className={styles.pagina}>
        <h1 className="titulo">Relatório de Perfil do Eleitorado</h1>
        <h2 className={styles.subtitulo}>Tipo: {labelTipo}</h2>

        {perfilAplicado && (
          <section className={styles.perfilAplicado}>
            <h3 className={styles.perfilTitulo}>Perfil Aplicado</h3>
            <div className={styles.perfilGrid}>
              <div>
                <strong>UF:</strong> {perfilAplicado.sigla_estado || "-"}
              </div>
              <div>
                <strong>Município:</strong>{" "}
                {perfilAplicado.nome_municipio || "Todos"}
              </div>
              <div>
                <strong>Agrupamento:</strong>{" "}
                {LABEL_AGRUPAMENTO[perfilAplicado.tipo_agrupamento] ||
                  perfilAplicado.tipo_agrupamento ||
                  "-"}
              </div>
              <div>
                <strong>Métrica:</strong>{" "}
                {LABEL_METRICA[perfilAplicado.metrica_ranking] ||
                  perfilAplicado.metrica_ranking ||
                  "-"}
              </div>
              <div>
                <strong>Direção:</strong>{" "}
                {perfilAplicado.direcao_ranking || "-"}
              </div>
              <div>
                <strong>Considera não informados:</strong>{" "}
                {perfilAplicado.considerar_nao_informados === false
                  ? "Não"
                  : "Sim"}
              </div>
            </div>

            {perfilAplicado.resumo_texto && (
              <p className={styles.perfilResumo}>
                <strong>Resumo:</strong> {perfilAplicado.resumo_texto}
              </p>
            )}

            {!!perfilAplicado.categorias?.length && (
              <div className={styles.categorias}>
                {perfilAplicado.categorias.map((categoria) => (
                  <div
                    key={categoria.categoria}
                    className={styles.categoriaItem}
                  >
                    <strong>
                      {categoria.categoria_label || categoria.categoria}:
                    </strong>{" "}
                    {(categoria.valores || [])
                      .map((valor) => valor.descricao)
                      .join(", ") || "-"}
                  </div>
                ))}
              </div>
            )}
          </section>
        )}
      </div>

      {tipo === "municipio" && (
        <div className={styles.pagina}>
          <table className={styles.tabela}>
            <thead>
              <tr>
                <th>Ranking</th>
                <th>Município</th>
                <th>Quantidade de Eleitores</th>
                <th>% no Agrupamento</th>
                <th>% no Total Filtrado</th>
              </tr>
            </thead>
            <tbody>
              {dados.map((municipio) => (
                <tr key={municipio.id_municipio}>
                  <td>{municipio.ranking ?? "-"}</td>
                  <td>{municipio.nome_municipio}</td>
                  <td>{formatoNumero(municipio.quantidade_eleitores)}</td>
                  <td>{formatoPercentual(municipio.percentual_no_agrupamento)}</td>
                  <td>{formatoPercentual(municipio.percentual_no_total_filtrado)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tipo === "zona" &&
        dados.map((municipio) => (
          <div className={styles.pagina} key={municipio.id_municipio}>
            <h2 className={styles.tituloGrupo}>
              Município: {municipio.nome_municipio}
            </h2>

            <table className={styles.tabela}>
              <thead>
                <tr>
                  <th>Ranking</th>
                  <th>Zona</th>
                  <th>Quantidade de Eleitores</th>
                  <th>% no Agrupamento</th>
                  <th>% no Total Filtrado</th>
                </tr>
              </thead>
              <tbody>
                {(municipio.zonas || []).map((zona) => (
                  <tr key={zona.id_zona}>
                    <td>{zona.ranking ?? "-"}</td>
                    <td>{zona.numero_zona}</td>
                    <td>{formatoNumero(zona.quantidade_eleitores)}</td>
                    <td>{formatoPercentual(zona.percentual_no_agrupamento)}</td>
                    <td>{formatoPercentual(zona.percentual_no_total_filtrado)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}

      {tipo === "local_votacao" &&
        dados.map((municipio) => (
          <div key={municipio.id_municipio}>
            {(municipio.zonas || []).map((zona) => (
              <div className={styles.pagina} key={zona.id_zona}>
                <h2 className={styles.tituloGrupo}>
                  Município: {municipio.nome_municipio}
                </h2>
                <h3 className={styles.subGrupo}>Zona: {zona.numero_zona}</h3>

                <table className={styles.tabela}>
                  <thead>
                    <tr>
                      <th>Ranking</th>
                      <th>Local de Votação</th>
                      <th>Endereço</th>
                      <th>Bairro</th>
                      <th>Quantidade de Eleitores</th>
                      <th>% no Agrupamento</th>
                      <th>% no Total Filtrado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(zona.locais || []).map((local) => (
                      <tr key={local.id_local_votacao}>
                        <td>{local.ranking ?? "-"}</td>
                        <td>{local.nome_local_votacao}</td>
                        <td>{local.endereco_local_votacao || "-"}</td>
                        <td>{local.bairro_local_votacao || "-"}</td>
                        <td>{formatoNumero(local.quantidade_eleitores)}</td>
                        <td>{formatoPercentual(local.percentual_no_agrupamento)}</td>
                        <td>
                          {formatoPercentual(local.percentual_no_total_filtrado)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        ))}
    </div>
  );
};

export default RelatorioPerfilEleitorado;
